export enum PublishProductsType {
  PRODUCT = 'PRODUCT',
  PRICING = 'PRICING',
}

export interface IPublishProductsRequestBody {
  publish_type: PublishProductsType[];
  category_ids?: string[];
  price_scheme_id?: string;
  venues?: string[];
  excluded_item_ids?: string[];
  publication_date_time?: string | undefined;
}

export interface IPublishProductsResponse {
  event_id: string;
}
